import { LinkButton, UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './CianMortgageButton.css';

interface ICianMortgageButtonProps {
  url: string;
  text: string;
  onClick: () => void;
}

export const CianMortgageButton: React.FC<ICianMortgageButtonProps> = props => {
  const { url, text, onClick } = props;

  return (
    <div className={style['cian-mortgage-button']}>
      <LinkButton
        theme="fill_primary"
        href={url}
        size="M"
        onClick={onClick}
        data-testid="CianMortgageButton"
        target="_blank"
      >
        {text}
      </LinkButton>
      <div className={style['description']}>
        <UIText3 color="text-secondary-default" textAlign="right">
          Заявка&nbsp;— единая для всех банков. Не оферта. Перед&nbsp;заполнением попросим авторизоваться.
        </UIText3>
      </div>
    </div>
  );
};
